/**
 * Terms of Service and Privacy Policy live on the marketing site,
 * releve.life — the official copies, linked from the app footer and from
 * Keycloak's Terms and Conditions screen (KEYCLOAK_SETUP.md "Terms and
 * Conditions").
 *
 * The old in-app /legal/:kind pages are kept only as redirects so links
 * already sent out (emails, earlier terms screens) still land somewhere.
 * apps/web/vercel.json redirects them server-side; LegalDocumentPage covers
 * client-side navigation and local dev. Keep all three in step.
 */

export const LEGAL_DOCUMENT_URLS = {
  'terms-of-service': 'https://releve.life/terms',
  'privacy-policy': 'https://releve.life/privacy',
} as const;

export type LegalDocumentKind = keyof typeof LEGAL_DOCUMENT_URLS;

export function isLegalDocumentKind(value: string | undefined): value is LegalDocumentKind {
  return Object.prototype.hasOwnProperty.call(LEGAL_DOCUMENT_URLS, value ?? '');
}
